import { Tabs } from 'antd';
import JournalDraftAudit from 'components/JournalDrafts/JournalDraftAudit';
import { useSearchParams } from 'react-router-dom';
import Table from '../Table';
import styles from './index.module.scss';

// `?view=ai-drafts` deep-links to the AI journal drafts audit tab (spec §10).
const AI_DRAFTS_VIEW = 'ai-drafts';

const JournalEntriesMain = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const activeKey =
		searchParams.get('view') === AI_DRAFTS_VIEW ? AI_DRAFTS_VIEW : 'journals';

	return (
		<div
			className={styles['journal-entries-container']}
			data-tour-target="tutorial-journal-entries"
		>
			<Tabs
				activeKey={activeKey}
				className={styles['journal-entries-tabs']}
				onChange={(key) => {
					const next = new URLSearchParams(searchParams);
					if (key === AI_DRAFTS_VIEW) {
						next.set('view', AI_DRAFTS_VIEW);
					} else {
						next.delete('view');
					}
					setSearchParams(next, { replace: true });
				}}
				destroyInactiveTabPane
				items={[
					{ key: 'journals', label: 'Journal Entries', children: <Table /> },
					{
						key: AI_DRAFTS_VIEW,
						label: 'AI Journal Drafts',
						children: <JournalDraftAudit />,
					},
				]}
			/>
		</div>
	);
};

export default JournalEntriesMain;
